import React from "react";
import { ChoiceChip } from "./ProfileParts";
import { COUNTS_AS_TAGS } from "../../utils/trainingBalance";

const LABELS = {
  resistance: "Strength",
  anaerobic: "Hard intervals",
  aerobic: "Cardio",
};

/**
 * Which weekly targets a session counts toward (#173). Any, all or none:
 * strength with an interval finisher counts twice, a stretch counts toward
 * none. `value` is the tags; tapping one adds or removes it.
 */
const CountsAsPicker = ({ value = [], onChange, id }) => {
  const toggle = (tag) =>
    onChange(
      value.includes(tag)
        ? value.filter((t) => t !== tag)
        : COUNTS_AS_TAGS.filter((t) => t === tag || value.includes(t)),
    );
  return (
    <div className="grid gap-1.5" role="group" aria-labelledby={id}>
      <div className="grid grid-cols-3 gap-1.5">
        {COUNTS_AS_TAGS.map((tag) => (
          <ChoiceChip
            key={tag}
            selected={value.includes(tag)}
            onClick={() => toggle(tag)}
            className="rounded-lg px-2.5 leading-tight"
          >
            {LABELS[tag]}
          </ChoiceChip>
        ))}
      </div>
      <p className="text-xs leading-snug text-muted-foreground">
        {value.length === 0
          ? "Counts toward none of your weekly targets."
          : "Counts toward your weekly targets. Tap to change."}
      </p>
    </div>
  );
};

export default CountsAsPicker;
